import { render, staticRenderFns } from "./TabsUnderlineNew.vue?vue&type=template&id=38e2f303&scoped=true"
import script from "./TabsUnderlineNew.vue?vue&type=script&lang=ts"
export * from "./TabsUnderlineNew.vue?vue&type=script&lang=ts"
import style0 from "./TabsUnderlineNew.vue?vue&type=style&index=0&id=38e2f303&lang=scss&scoped=true"
import style1 from "./TabsUnderlineNew.vue?vue&type=style&index=1&id=38e2f303&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2f303",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e2f303')) {
      api.createRecord('38e2f303', component.options)
    } else {
      api.reload('38e2f303', component.options)
    }
    module.hot.accept("./TabsUnderlineNew.vue?vue&type=template&id=38e2f303&scoped=true", function () {
      api.rerender('38e2f303', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabs/TabsUnderlineNew.vue"
export default component.exports